(function () {
  'use strict';

  /**
   * tl-quickbuy-size-default.js
   * After the QuickBuyModal renders, default the size selection to "L".
   * Prestige theme uses label.block-swatch elements (not radio inputs by value).
   */

  var DEFAULT_SIZE = 'L';

  function selectDefaultSize(modal) {
    // Find all block-swatch labels inside the modal
    var labels = Array.prototype.slice.call(modal.querySelectorAll('label.block-swatch'));
    
    // Find the L label by its text content
    var lLabel = null;
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].textContent.trim() === DEFAULT_SIZE) {
        lLabel = labels[i];
        break;
      }
    }
    
    if (lLabel) {
      // Check if the associated input is already checked
      var forId = lLabel.getAttribute('for');
      var input = forId ? document.getElementById(forId) : null;
      if (input && !input.checked) {
        lLabel.click();
      }
      return;
    }

    // Fallback: look for a radio input with value matching the size (unlikely but safe)
    var radioInput = modal.querySelector('input[type="radio"][value="' + DEFAULT_SIZE + '"]');
    if (radioInput && !radioInput.checked) {
      radioInput.click();
    }
  }

  function patchWhenReady() {
    var QuickBuyModal = customElements.get('quick-buy-modal');
    if (!QuickBuyModal) {
      // Element not defined yet — wait for it
      customElements.whenDefined('quick-buy-modal').then(patchWhenReady);
      return;
    }

    var originalShow = QuickBuyModal.prototype.show;
    if (originalShow && originalShow._tlPatched) return; // already patched

    QuickBuyModal.prototype.show = function () {
      var self = this;
      var result = originalShow.apply(this, arguments);
      // Two rAF frames to ensure the variant picker has fully rendered
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          selectDefaultSize(self);
        });
      });
      return result;
    };
    QuickBuyModal.prototype.show._tlPatched = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchWhenReady);
  } else {
    patchWhenReady();
  }
})();